<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Incidents</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="sites">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.user_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>account_circle</mat-icon> Affected Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="contractors">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectContractors()"
        [matBadge]="'' + (filters.contractor_ids.length || 'All')"
        class="mx-3 mt-2">
        <fa-icon [icon]="faHardHat"></fa-icon> Affected {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="assets">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectAssets()"
        [matBadge]="'' + (filters.asset_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>forklift</mat-icon> Assets
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 180px;">
        <mat-label>Type</mat-label>
        <mat-select
          placeholder="Type"
          class="filter-dropdowns"
          [(ngModel)]="filters.type"
          matTooltip="Filter incidents by type."
          name="type">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let incident_type of utils.getIncidentTypes()" [value]="incident_type">{{ incident_type
            }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="who_was_involved">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 180px;">
        <mat-label>Who was involved?</mat-label>
        <mat-select
          placeholder="Who was involved?"
          class="filter-dropdowns"
          [(ngModel)]="filters.who_was_involved"
          matTooltip="Filter incidents by who was involved."
          name="who_was_involved">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let option of who_was_involved_options" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 140px;">
        <mat-label>Status</mat-label>
        <mat-select
          placeholder="Status"
          class="filter-dropdowns"
          [(ngModel)]="filters.status"
          matTooltip="Filter incidents by status."
          name="status">
          <mat-option value="">All</mat-option>
          <mat-option [value]="status.toLowerCase()" *ngFor="let status of utils.getIncidentStatuses()">{{ status
            }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker
        dateRangeTitle="Select Date Range"
        dateRangePlaceholder="Select Date Range"
        dateRangeTooltip="Filter incidents by date range."
        [dateRangeInput]="filters.date_range"
        (dateRangeOutput)="getOutputDateRange($event)">
      </app-date-range-picker>
    </div>
  </ng-container>

  <ng-container matColumnDef="worksafe_notification">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 200px;">
        <mat-label>{{ utils.getLangTerm('incidents.filter.worksafe_notification', 'Notification Required') }}</mat-label>
        <mat-select
          [placeholder]="utils.getLangTerm('incidents.filter.worksafe_notification', 'Notification Required')"
          class="filter-dropdowns"
          [(ngModel)]="filters.worksafe_notification"
          matTooltip="Filter incidents by notification status."
          name="worksafe_notification">
          <mat-option value="">All</mat-option>
          <mat-option value="1">Yes</mat-option>
          <mat-option value="0">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filters
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon>clear_all</mat-icon> Clear Filters
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
